{{#if (and interface.hasSlavePorts (or (and isRequest (not isPipelined)) isResponse))}}
virtual task send_response();
  {{> (partial "uvm-driver/drive-item") context=. bfmTask=(or (and isRequest slaveRequestBfm.respondTask) bfmTask) }}
endtask
{{/if}}
